var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,6H.5A.5.5,0,0,1,0,5.5V.5A.5.5,0,0,1,.5,0h23a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,23.5,6ZM1,5H23V1H1Zm22.5,9H.5a.5.5,0,0,1-.5-.5v-5A.5.5,0,0,1,.5,8h23a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,23.5,14ZM1,13H23V9H1Zm22.5,9H.5a.5.5,0,0,1-.5-.5v-5A.5.5,0,0,1,.5,16h23a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,23.5,22ZM1,21H23V17H1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.1e3451ce7e2d6197cfcae7d7ff2869fa.svg";
export { ForwardRef as ReactComponent };